import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-env browser */
/* eslint-disable no-underscore-dangle, no-param-reassign */

const pointToLineDistance = (point, lineStart, lineEnd) => {
  const A = point.x - lineStart.x;
  const B = point.y - lineStart.y;
  const C = lineEnd.x - lineStart.x;
  const D = lineEnd.y - lineStart.y;
  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  let param = -1;
  if (lenSq !== 0) {
    param = dot / lenSq;
  }
  let xx;
  let yy;
  if (param < 0) {
    xx = lineStart.x;
    yy = lineStart.y;
  } else if (param > 1) {
    xx = lineEnd.x;
    yy = lineEnd.y;
  } else {
    xx = lineStart.x + param * C;
    yy = lineStart.y + param * D;
  }
  const dx = point.x - xx;
  const dy = point.y - yy;
  return Math.sqrt(dx * dx + dy * dy);
};
const getActivityLayersArray = activityGroup => {
  var _activityGroup$layers;
  if (!(activityGroup !== null && activityGroup !== void 0 && activityGroup.layers)) return [];
  if (Array.isArray(activityGroup.layers)) {
    return activityGroup.layers;
  }
  if (typeof activityGroup.layers.forEach === 'function') {
    const layersArray = [];
    activityGroup.layers.forEach(layer => {
      layersArray.push(layer);
    });
    return layersArray;
  }
  if ((_activityGroup$layers = activityGroup.layers) !== null && _activityGroup$layers !== void 0 && _activityGroup$layers.length) {
    const layersArray = [];
    for (let i = 0; i < activityGroup.layers.length; i += 1) {
      const layer = activityGroup.layers.getItemAt ? activityGroup.layers.getItemAt(i) : activityGroup.layers[i];
      if (layer) layersArray.push(layer);
    }
    return layersArray;
  }
  return [];
};
const isNavigableActivityGraphic = graphic => {
  var _graphic$attributes, _graphic$attributes2;
  return Boolean((graphic === null || graphic === void 0 || (_graphic$attributes = graphic.attributes) === null || _graphic$attributes === void 0 ? void 0 : _graphic$attributes.activityType) && (graphic === null || graphic === void 0 || (_graphic$attributes2 = graphic.attributes) === null || _graphic$attributes2 === void 0 ? void 0 : _graphic$attributes2.formID));
};

/** Min distance from screenPoint to graphic, or null to skip. */
const getMinDistanceToActivityGraphic = (view, graphic, screenPoint) => {
  var _graphic$geometry;
  if (!isNavigableActivityGraphic(graphic) || !((_graphic$geometry = graphic.geometry) !== null && _graphic$geometry !== void 0 && _graphic$geometry.paths)) return null;
  try {
    let minDistance = Infinity;
    graphic.geometry.paths.forEach(polylinePath => {
      const screenPath = polylinePath.map(point => view.toScreen({
        type: 'point',
        x: point[0],
        y: point[1],
        spatialReference: graphic.geometry.spatialReference
      }));
      for (let k = 0; k < screenPath.length - 1; k += 1) {
        const p1 = screenPath[k];
        const p2 = screenPath[k + 1];
        if (p1 && p2 && !Number.isNaN(p1.x) && !Number.isNaN(p1.y) && !Number.isNaN(p2.x) && !Number.isNaN(p2.y)) {
          minDistance = Math.min(minDistance, pointToLineDistance(screenPoint, p1, p2));
        }
      }
    });
    return minDistance;
  } catch (_unused) {
    return null;
  }
};
const findClosestActivityGraphic = (view, activityGroup, screenPoint, tolerancePx) => {
  if (!(activityGroup !== null && activityGroup !== void 0 && activityGroup.layers)) return null;
  const layersArray = getActivityLayersArray(activityGroup);
  let bestGraphic = null;
  let bestDistance = Infinity;
  let foundWithinTolerance = false;
  for (let i = 0; i < layersArray.length && !foundWithinTolerance; i += 1) {
    const layer = layersArray[i];
    if ((layer === null || layer === void 0 ? void 0 : layer.type) !== 'graphics' || !layer.graphics) {
      // skip non-graphics layers (no continue per lint)
    } else {
      for (let j = 0; j < layer.graphics.length; j += 1) {
        const graphic = layer.graphics.getItemAt(j);
        const distance = getMinDistanceToActivityGraphic(view, graphic, screenPoint);
        if (distance != null && distance < bestDistance) {
          bestDistance = distance;
          bestGraphic = graphic;
          if (bestDistance <= tolerancePx) {
            foundWithinTolerance = true;
            break;
          }
        }
      }
    }
  }
  if (bestGraphic && bestDistance <= tolerancePx) return bestGraphic;
  return null;
};
const createSegmentInteractions = _ref => {
  let view = _ref.view,
    activityLayersRef = _ref.activityLayersRef,
    hoveredGraphicRef = _ref.hoveredGraphicRef,
    cabinetIdentifier = _ref.cabinetIdentifier,
    setSelectedFeature = _ref.setSelectedFeature,
    setPopoverPoint = _ref.setPopoverPoint,
    hoverLineWidth = _ref.hoverLineWidth,
    hoverTolerance = _ref.hoverTolerance,
    clickTolerance = _ref.clickTolerance;
  const clearHoverHighlight = () => {
    const _hoveredGraphicRef$cu = hoveredGraphicRef.current,
      graphic = _hoveredGraphicRef$cu.graphic,
      originalSymbol = _hoveredGraphicRef$cu.originalSymbol;
    if ((graphic === null || graphic === void 0 ? void 0 : graphic.symbol) != null && originalSymbol != null) {
      graphic.symbol = originalSymbol;
    }
    hoveredGraphicRef.current = {
      graphic: null,
      originalSymbol: null
    };
  };
  const handleMapClick = async event => {
    const clickX = event.x;
    const clickY = event.y;
    setSelectedFeature(null);
    setPopoverPoint(null);
    try {
      const activityGroup = activityLayersRef.current._group;
      let hitTestResult;
      try {
        const hitTestOptions = activityGroup ? {
          include: activityGroup
        } : {};
        hitTestResult = await view.hitTest(event, hitTestOptions);
      } catch (hitTestError) {
        hitTestResult = {
          results: []
        };
      }
      let graphicResult = hitTestResult.results.find(result => {
        const resultGraphic = result.graphic;
        return isNavigableActivityGraphic(resultGraphic);
      });
      const closestGraphic = findClosestActivityGraphic(view, activityGroup, {
        x: clickX,
        y: clickY
      }, clickTolerance);
      if (closestGraphic) {
        graphicResult = {
          graphic: closestGraphic
        };
      }
      if (graphicResult) {
        const _graphicResult$graphi = graphicResult.graphic.attributes,
          formID = _graphicResult$graphi.formID,
          activityCabinetIdentifier = _graphicResult$graphi.cabinetIdentifier;
        if (formID) {
          var _event$stopPropagatio, _event$preventDefault;
          (_event$stopPropagatio = event.stopPropagation) === null || _event$stopPropagatio === void 0 || _event$stopPropagatio.call(event);
          (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
          const targetCabinetIdentifier = activityCabinetIdentifier || cabinetIdentifier;
          setSelectedFeature(_objectSpread(_objectSpread({}, graphicResult.graphic.attributes), {}, {
            cabinetIdentifier: targetCabinetIdentifier || null,
            title: graphicResult.graphic.attributes.activityType
          }));
          setPopoverPoint({
            x: clickX,
            y: clickY
          });
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Error handling map click:', error);
    }
  };
  let pointerMoveRafId = null;
  let lastPointerPoint = null;
  const dispose = () => {
    var _view$container;
    if (pointerMoveRafId != null) {
      cancelAnimationFrame(pointerMoveRafId);
      pointerMoveRafId = null;
    }
    lastPointerPoint = null;
    clearHoverHighlight();
    if (view !== null && view !== void 0 && (_view$container = view.container) !== null && _view$container !== void 0 && _view$container.style) {
      view.container.style.cursor = 'default';
    }
  };
  const handlePointerMove = event => {
    lastPointerPoint = {
      x: event.x,
      y: event.y
    };
    if (pointerMoveRafId != null) return;
    pointerMoveRafId = requestAnimationFrame(async () => {
      pointerMoveRafId = null;
      const point = lastPointerPoint;
      try {
        if (!point) return;
        const activityGroup = activityLayersRef.current._group;
        if (!activityGroup) {
          clearHoverHighlight();
          view.container.style.cursor = 'default';
          return;
        }
        let graphicUnderCursor = null;
        try {
          const hitTestResult = await view.hitTest(point, {
            include: activityGroup
          });
          const hit = hitTestResult.results.find(result => isNavigableActivityGraphic(result.graphic));
          if (hit) graphicUnderCursor = hit.graphic;
        } catch (_unused2) {
          // hitTest threw; fall through to findClosestActivityGraphic below
        }
        if (!graphicUnderCursor) {
          graphicUnderCursor = findClosestActivityGraphic(view, activityGroup, point, hoverTolerance);
        }
        const prev = hoveredGraphicRef.current;
        if (graphicUnderCursor) {
          view.container.style.cursor = 'pointer';
          if (prev.graphic === graphicUnderCursor) return;
          clearHoverHighlight();
          if (graphicUnderCursor.symbol) {
            const originalSymbol = graphicUnderCursor.symbol;
            const hoverSymbol = originalSymbol !== null && originalSymbol !== void 0 && originalSymbol.clone ? originalSymbol.clone() : _objectSpread({}, originalSymbol);
            if (hoverSymbol) {
              hoverSymbol.width = hoverLineWidth;
              hoveredGraphicRef.current = {
                graphic: graphicUnderCursor,
                originalSymbol
              };
              graphicUnderCursor.symbol = hoverSymbol;
            }
          }
        } else {
          view.container.style.cursor = 'default';
          clearHoverHighlight();
        }
      } catch (error) {
        clearHoverHighlight();
        view.container.style.cursor = 'default';
      }
    });
  };
  return {
    handleMapClick,
    handlePointerMove,
    clearHoverHighlight,
    dispose
  };
};
export default createSegmentInteractions;